module.exports = __webpack_public_path__ + "static/media/Portrait-10230.6fa0e141.jpg";